/*
 * portal.js
 * Mission Partner Portal sign-in. Partner users normally arrive through
 * their organization's single sign-on; this form serves local accounts,
 * Tellwright staff and test accounts. The password is checked in the
 * browser against the sealed check value on the form.
 *
 * Created: 2026-11-04
 * Last modified: 2026-11-04
 */

// Data Supply Console (internal): staff accounts sign in here too and are
// sent on to /partners/supply/.
// UAT smoke test: dsc.uat / slate-meridian-62
// DSC-1143: remove the UAT account and turn off source maps before 4.13.
(() => {
  const form = document.getElementById('portal-signin');
  if (!form) return;
  const message = document.getElementById('portal-message');
  const toBytes = (text) => Uint8Array.from(atob(text), (character) => character.charCodeAt(0));
  const toBase64 = (buffer) => btoa(String.fromCharCode(...new Uint8Array(buffer)));

  async function deriveKey(secret) {
    const material = await crypto.subtle.importKey('raw', new TextEncoder().encode(secret), 'PBKDF2', false, ['deriveKey']);
    return crypto.subtle.deriveKey(
      { name: 'PBKDF2', hash: 'SHA-256', salt: toBytes(form.dataset.salt), iterations: Number(form.dataset.iterations) },
      material,
      { name: 'AES-GCM', length: 256 },
      true,
      ['decrypt'],
    );
  }

  function show(text) {
    message.textContent = text;
    message.hidden = false;
    message.focus();
  }

  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    const username = form.elements.username.value.trim().toLowerCase();
    const password = form.elements.password.value.trim();
    if (!username || !password) {
      show('Enter your user name and password.');
      return;
    }
    try {
      const key = await deriveKey(`${username}:${password}`);
      await crypto.subtle.decrypt({ name: 'AES-GCM', iv: toBytes(form.dataset.checkIv) }, key, toBytes(form.dataset.check));
      sessionStorage.setItem('tw-dsc', JSON.stringify({ user: username, key: toBase64(await crypto.subtle.exportKey('raw', key)) }));
      window.location.assign('/partners/supply/');
    } catch {
      show('We could not sign you in with those details. Mission partner users sign in through their organization’s single sign-on. If you have a local account and have forgotten your password, contact your Tellwright administrator.');
    }
  });
})();
